import { render, staticRenderFns } from "./EBITDAGesamtJahre.vue?vue&type=template&id=31081dfd&"
import script from "./EBITDAGesamtJahre.vue?vue&type=script&lang=ts&"
export * from "./EBITDAGesamtJahre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports